export default {
  WIX_STUDIO_SELLING_YOUR_CUSTOM_TEMPLATE:
    'b912a4b4-c40f-4931-b5b4-dda0a72c8a06',
};
